// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"a525fb46","453":"1cc8bb2d","879":"b59c7ff0"}[chunkId] + ".chunk.js";
};